import React from 'react'
import View from './view.js'
import { useDataValue } from 'Simple/Data.js'

export default function Logic(props) {
  let [patient] = useDataValue({
    context: 'task',
    path: 'patients',
    viewPath: props.viewPath,
  })

  return (
    <View
      {...props}
      viewPatientPanel={patient?.id && props.is_hovered}
      viewNo={!props.is_hovered}
    />
  )
}
